(function () {
    "use strict";

    angular
        .module("app")
        .directive("outsoleSearchHelp", ["SearchFactory", outsoleSearchHelp]);

    function outsoleSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.outsoleKey = "";
                        scope.outsoleName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.outsoleName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.outsoleSearch(scope.sapBrandId, function (outsole) {
                        scope.outsoleKey = outsole ? outsole.OutsoleKey : "";
                        scope.outsoleName = outsole ? outsole.OutsoleName : "";
                        scope.displayValue = scope.outsoleName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.$watch("outsoleName", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.outsoleName;
                scope.prevDisplayValue = scope.displayValue;
                
            },
            scope: { outsoleKey: "=", outsoleName: "=", readOnly: "=", sapBrandId: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

